import { h, s } from '../lib/dom';

interface Pillar {
  tag: string;
  title: string;
  glyph: () => SVGSVGElement;
}

const PILLARS: Pillar[] = [
  {
    tag: 'ACT',
    title: 'Actor',
    glyph: () => glyph(
      s('circle', { cx: 28, cy: 20, r: 7, fill: 'none', stroke: 'currentColor', 'stroke-width': 1.4 }),
      s('path', { d: 'M16 44 C16 34, 40 34, 40 44', fill: 'none', stroke: 'currentColor', 'stroke-width': 1.4, 'stroke-linecap': 'round' }),
      s('circle', { cx: 28, cy: 20, r: 2.4, fill: '#06038D' }),
    ),
  },
  {
    tag: '01',
    title: 'Research',
    glyph: () => glyph(
      s('circle', { cx: 28, cy: 28, r: 12, fill: 'none', stroke: 'currentColor', 'stroke-width': 1.4 }),
      s('path', { d: 'M37 37 L48 48', stroke: 'currentColor', 'stroke-width': 1.6, 'stroke-linecap': 'round' }),
      s('circle', { cx: 28, cy: 28, r: 3, fill: '#FF9933' }),
    ),
  },
  {
    tag: '02',
    title: 'Technology',
    glyph: () => glyph(
      s('rect', { x: 8, y: 14, width: 40, height: 28, rx: 4, fill: 'none', stroke: 'currentColor', 'stroke-width': 1.4 }),
      s('path', { d: 'M18 48 H38', stroke: 'currentColor', 'stroke-width': 1.4, 'stroke-linecap': 'round' }),
      s('circle', { cx: 28, cy: 28, r: 3, fill: '#138808' }),
    ),
  },
  {
    tag: '03',
    title: 'Policy',
    glyph: () => glyph(
      s('path', { d: 'M14 44 V20 L28 12 L42 20 V44 Z', fill: 'none', stroke: 'currentColor', 'stroke-width': 1.4, 'stroke-linejoin': 'round' }),
      s('path', { d: 'M22 44 V30 H34 V44', fill: 'none', stroke: 'currentColor', 'stroke-width': 1.4 }),
      s('circle', { cx: 28, cy: 22, r: 2.4, fill: '#06038D', stroke: '#fff', 'stroke-width': 1 }),
    ),
  },
  {
    tag: 'ART',
    title: 'Root ART',
    glyph: () => glyph(
      s('path', { d: 'M28 10 L32 22 L45 22 L34 30 L38 43 L28 35 L18 43 L22 30 L11 22 L24 22 Z', fill: 'none', stroke: 'currentColor', 'stroke-width': 1.4, 'stroke-linejoin': 'round' }),
      s('circle', { cx: 28, cy: 28, r: 2.4, fill: '#FF9933' }),
    ),
  },
];

const OPERATORS = ['(', 'x', 'x', ')', '=>'];

function glyph(...children: SVGElement[]): SVGSVGElement {
  const svg = s('svg', {
    xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 56 56',
    width: 56, height: 56, class: 'glyph', 'aria-hidden': 'true',
  });
  children.forEach((c) => svg.append(c));
  return svg;
}

export function renderPillars(): HTMLElement {
  const formula = h('div', { class: 'art-formula' });

  for (let i = 0; i < PILLARS.length; i += 1) {
    const p = PILLARS[i];
    formula.append(
      h('article', { class: 'pillar art-card reveal' },
        p.glyph(),
        h('span', { class: 'num' }, p.tag),
        h('h3', {}, p.title),
      ),
    );

    const op = OPERATORS[i];
    if (op) {
      formula.append(
        h('span', { class: 'formula-op', 'aria-hidden': 'true' }, op),
      );
    }
  }

  return h('section', { 'aria-label': 'Work' },
    h('div', { class: 'container' },
      h('header', { class: 'section-head reveal' },
        h('h2', {}, 'Actor (Research x Technology x Policy)'),
        h('p', {}, 'Rooted in ART.'),
      ),
      formula,
    ),
  );
}
